import React from "react";

export const AlertTypes = {
  SUCCESS: "SUCCESS",
  ERROR: "ERROR",
};

export type AlertTypes = (typeof AlertTypes)[keyof typeof AlertTypes];
export type PushAlertType = (type: string, message: string) => void;

export type AlertContextType = {
  alerts: Map<string, AlertType>;
  pushAlert: PushAlertType;
  removeAlert: (id: string) => void;
};

export type AlertType = {
  id: string;
  type: AlertTypes;
  message: string;
  timer: NodeJS.Timeout;
};

export type AlertProviderProps = {
  children: React.ReactNode;
};

export type AlertProps = {
  message: string;
  onClose: () => void;
};
